// Core
import styled from 'styled-components';

export const ListContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  padding-bottom: 32px;
    
  /* Apply padding-right on first and second children */
  & > :nth-child(1),
  & > :nth-child(2) {
    padding-right: 24px;
  };
`;

export const Container = styled.div`
  padding-bottom: 32px;
  height: 100%;
`;
